<template>

  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="业绩周期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label=""><el-input v-model="formInline.multigroup_activity_id" placeholder="请输入轨道ID"></el-input></el-form-item>
        <el-form-item label=""><el-input v-model="formInline.user_id" placeholder="请输入团队长ID"></el-input></el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
      </el-form>
    </div>
    
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="user_id" label="用户ID" width="80" sortable="custom"></el-table-column>
             <el-table-column prop="nickName" label="用户" width="200">
              <template slot-scope="scope">
                <div class="d-s-c">
                  <img :src="scope.row.user.avatarUrl" width="50px" height="50px" />
                  <div class="ml10">
                    <p class="f14 fb">{{ scope.row.user.nickName }}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="活动名称">
               <template slot-scope="scope">
                <div class="d-s-c">
                   【{{ scope.row.multigroup_activity_id }}】{{ scope.row.active.title }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="leader_commission" label="团队奖励">
               <template slot-scope="scope">
                <div class="d-s-c">
                    {{ scope.row.amount }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="join_num" label="来源用户">
               <template slot-scope="scope">
                 <div class="d-s-c">
                  <img :src="scope.row.fromuser.avatarUrl" width="50px" height="50px" />
                  <div class="ml10">
                    <p class="f14 fb">{{ scope.row.fromuser.nickName }}</p>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="state_text" label="状态" width="120"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MultigroupApi from '@/api/multigroup.js';
import qs from 'qs';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未启用', '启用']
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      MultigroupApi.activeLogDetails(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },
onExport: function() {
      // console.log(this.formInline);return;
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.multigroup.active/exportLogDetails?' + qs.stringify(this.formInline);
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/multigroup/log/index.vue